(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const productNode = document.querySelector('[data-recently-viewed-product]');
  if (productNode) {
    const item = {
      handle: productNode.dataset.productHandle,
      title: productNode.dataset.productTitle,
      url: productNode.dataset.productUrl,
      image: productNode.dataset.productImage
    };
    const key = 'charath_recently_viewed';
    const existing = JSON.parse(localStorage.getItem(key) || '[]').filter(product => product.handle !== item.handle);
    localStorage.setItem(key, JSON.stringify([item].concat(existing).slice(0, 8)));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.querySelectorAll('[data-search-fallback]').forEach((fallback) => {
    const query = fallback.dataset.query;
    const endpoint = fallback.dataset.url || '/search/suggest.json';
    const resultsGrid = fallback.parentElement.querySelector('[data-search-results]');
    if (!query || !resultsGrid) return;
    if (resultsGrid.children.length > 0) return;
    fallback.hidden = false;

    const params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '8');

    fetch(`${endpoint}?${params.toString()}`)
      .then((response) => response.ok ? response.json() : null)
      .then((payload) => {
        const products = payload?.resources?.results?.products || [];
        if (!products.length) {
          fallback.hidden = true;
          return;
        }

        fallback.hidden = true;
        products.forEach((product) => {
          const card = document.createElement('a');
          card.className = 'product-card';
          card.href = product.url;

          const media = document.createElement('span');
          media.className = 'product-card__media';
          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = product.featured_image?.alt || product.title;
            image.loading = 'lazy';
            media.append(image);
          }

          const body = document.createElement('span');
          body.className = 'product-card__body';

          const title = document.createElement('span');
          title.className = 'product-card__title';
          title.textContent = product.title;
          body.append(title);

          if (product.price) {
            const price = document.createElement('span');
            price.className = 'price';
            price.textContent = product.price;
            body.append(price);
          }

          card.append(media, body);
          resultsGrid.append(card);
        });
      })
      .catch(() => {
        fallback.hidden = true;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const recommendationSections = document.querySelectorAll('[data-product-recommendations]');
  recommendationSections.forEach(async section => {
    if (section.dataset.loaded) return;
    try {
      const response = await fetch(section.dataset.url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const replacement = html.querySelector('[data-product-recommendations]');
      if (replacement && replacement.innerHTML.trim()) {
        section.innerHTML = replacement.innerHTML;
        section.dataset.loaded = 'true';
      }
    } catch (error) {
      section.hidden = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
  document.querySelectorAll('[data-recently-viewed]').forEach(section => {
    const current = document.querySelector('[data-recently-viewed-product]');
    const currentHandle = current ? current.dataset.productHandle : '';
    const grid = section.querySelector('[data-recently-viewed-grid]');
    const products = JSON.parse(localStorage.getItem('charath_recently_viewed') || '[]').filter(product => product.handle !== currentHandle).slice(0, 4);
    if (!products.length) {
      section.hidden = true;
      return;
    }
    grid.innerHTML = products.map(product => {
      const image = product.image ? `<img src="${product.image}" alt="">` : `<span class="recently-viewed__blank"></span>`;
      return `<a class="recently-viewed__item" href="${product.url}">${image}<span>${product.title}</span></a>`;
    }).join('');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  (() => {
    const escapeHtml = value => String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));

    if (!customElements.get('predictive-search')) {
      class PredictiveSearch extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input[type="search"]');
          this.results = this.querySelector('.predictive-search__results');
          if (!this.input || !this.results) return;
          this.input.addEventListener('focus', () => this.renderSuggestions());
          this.input.addEventListener('input', this.onInput.bind(this));
          document.addEventListener('click', event => {
            if (!this.contains(event.target)) this.close();
          });
        }
        readRecent() {
          return JSON.parse(localStorage.getItem('charath_recent_searches') || '[]').slice(0, 5);
        }
        saveRecent(query) {
          const next = [query].concat(this.readRecent().filter(item => item !== query)).slice(0, 6);
          localStorage.setItem('charath_recent_searches', JSON.stringify(next));
        }
        renderSuggestions() {
          if (this.input.value.trim()) return;
          const recent = this.readRecent();
          const popular = ['3D printing', 'Filaments', 'Arduino', 'Development boards', 'Accessories'];
          this.results.innerHTML = `
            ${recent.length ? `<div class="predictive-search__group"><span class="predictive-search__label">Recent searches</span><div class="predictive-search__chips">${recent.map(item => `<button type="button" data-search-chip="${escapeHtml(item)}">${escapeHtml(item)}</button>`).join('')}</div></div>` : ''}
            <div class="predictive-search__group"><span class="predictive-search__label">Popular searches</span><div class="predictive-search__chips">${popular.map(item => `<a href="/search?q=${encodeURIComponent(item)}">${escapeHtml(item)}</a>`).join('')}</div></div>
          `;
          this.results.hidden = false;
          this.querySelectorAll('[data-search-chip]').forEach(button => {
            button.addEventListener('click', () => {
              this.input.value = button.dataset.searchChip;
              this.search(this.input.value);
            });
          });
        }
        onInput() {
          const query = this.input.value.trim();
          if (query.length < 2) {
            this.renderSuggestions();
            return;
          }
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.search(query), 140);
        }
        async search(query) {
          const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last`;
          try {
            const response = await fetch(url);
            const data = await response.json();
            const products = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
            const collections = data.resources && data.resources.results && data.resources.results.collections ? data.resources.results.collections : [];
            const pages = data.resources && data.resources.results && data.resources.results.pages ? data.resources.results.pages : [];
            const items = products.concat(collections).concat(pages);
            if (!items.length) {
              this.close();
              return;
            }
            this.saveRecent(query);
            this.results.innerHTML = items.map(item => {
              const image = item.image ? `<img src="${item.image}" alt="">` : `<span></span>`;
              const type = item.type || 'Result';
              return `<a class="predictive-search__item" href="${item.url}">${image}<span><strong>${escapeHtml(item.title)}</strong><span>${escapeHtml(type)}</span></span></a>`;
            }).join('');
            this.results.hidden = false;
            this.input.setAttribute('aria-expanded', 'true');
          } catch (error) {
            this.close();
          }
        }
        close() {
          this.results.hidden = true;
          this.results.innerHTML = '';
          this.input.setAttribute('aria-expanded', 'false');
        }
      }
      customElements.define('predictive-search', PredictiveSearch);
    }

    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function setupHeader(header) {
      if (!header || header.dataset.headerReady === 'true') return;
      header.dataset.headerReady = 'true';
      const drawer = header.querySelector('[data-site-drawer]');
      const panel = drawer ? drawer.querySelector('.site-drawer__panel') : null;
      const toggle = header.querySelector('[data-drawer-toggle]');
      const closeButton = header.querySelector('[data-drawer-close]');
      let previousFocus = null;
      let closeTimer = null;

      const setScrolled = () => {
        const waitForScroll = header.dataset.stickyAfterScroll !== 'false';
        header.classList.toggle('site-header--is-scrolled', waitForScroll ? window.scrollY > 8 : true);
      };
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          setScrolled();
          ticking = false;
        });
      };

      const getFocusable = () => drawer ? Array.from(drawer.querySelectorAll(focusableSelector)).filter(element => element.offsetParent !== null) : [];

      const closeDrawer = restoreFocus => {
        if (!drawer || drawer.hidden) return;
        drawer.dataset.open = 'false';
        drawer.setAttribute('aria-hidden', 'true');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('site-drawer-lock');
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (drawer.dataset.open !== 'true') drawer.hidden = true;
        }, 260);
        if (restoreFocus && previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
      };

      const openDrawer = () => {
        if (!drawer || !panel) return;
        previousFocus = document.activeElement;
        window.clearTimeout(closeTimer);
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('site-drawer-lock');
        window.requestAnimationFrame(() => {
          drawer.dataset.open = 'true';
          const focusable = getFocusable();
          (focusable[0] || panel).focus({ preventScroll: true });
        });
      };

      if (toggle) toggle.addEventListener('click', event => {
        event.preventDefault();
        if (drawer && drawer.dataset.open === 'true') closeDrawer(true);
        else openDrawer();
      });

      if (closeButton) closeButton.addEventListener('click', () => closeDrawer(true));

      if (drawer) {
        drawer.addEventListener('click', event => {
          if (event.target === drawer) closeDrawer(true);
          if (event.target.closest('[data-drawer-link]')) closeDrawer(false);
        });
        drawer.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeDrawer(true);
            return;
          }
          if (event.key !== 'Tab' || drawer.dataset.open !== 'true') return;
          const focusable = getFocusable();
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
        drawer.querySelectorAll('[data-submenu-toggle]').forEach(button => {
          button.addEventListener('click', () => {
            const submenu = document.getElementById(button.getAttribute('aria-controls'));
            const expanded = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', String(!expanded));
            if (submenu) submenu.hidden = expanded;
          });
        });
      }

      setScrolled();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    document.querySelectorAll('[data-site-header]').forEach(setupHeader);
    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('[data-site-header]').forEach(setupHeader);
    });

    const charathStore = {
      read(key) {
        return JSON.parse(localStorage.getItem(key) || '[]');
      },
      write(key, value) {
        localStorage.setItem(key, JSON.stringify(value.slice(0, 24)));
      },
      toggle(key, handle) {
        if (!handle) return;
        const items = this.read(key);
        const next = items.includes(handle) ? items.filter(item => item !== handle) : [handle].concat(items);
        this.write(key, next);
      }
    };
    document.addEventListener('click', event => {
      const card = event.target.closest('[data-product-card], [data-recently-viewed-product]');
      const handle = card ? card.dataset.productHandle : '';
      if (event.target.closest('[data-wishlist-toggle]')) charathStore.toggle('charath_wishlist', handle);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
